export default __webpack_public_path__ + "static/media/1d24ff2f3147eaf9dd769d2f6dad90a8.jpg";